var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4167 11.2721H15.0833V2.9388C15.0833 2.38627 14.8638 1.85636 14.4731 1.46566C14.0824 1.07496 13.5525 0.855469 13 0.855469C12.4475 0.855469 11.9176 1.07496 11.5269 1.46566C11.1362 1.85636 10.9167 2.38627 10.9167 2.9388V11.2721H2.58333C2.0308 11.2721 1.5009 11.4916 1.11019 11.8823C0.719494 12.273 0.5 12.8029 0.5 13.3555C0.5 13.908 0.719494 14.4379 1.11019 14.8286C1.5009 15.2193 2.0308 15.4388 2.58333 15.4388H10.9167V23.7721C10.9167 24.3247 11.1362 24.8546 11.5269 25.2453C11.9176 25.636 12.4475 25.8555 13 25.8555C13.5525 25.8555 14.0824 25.636 14.4731 25.2453C14.8638 24.8546 15.0833 24.3247 15.0833 23.7721V15.4388H23.4167C23.9692 15.4388 24.4991 15.2193 24.8898 14.8286C25.2805 14.4379 25.5 13.908 25.5 13.3555C25.5 12.8029 25.2805 12.273 24.8898 11.8823C24.4991 11.4916 23.9692 11.2721 23.4167 11.2721Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1611ecbbfa38d90f74ae5ea1e9881e67.svg";
export { ForwardRef as ReactComponent };